import './index.scss';

import React from "react";
import PropTypes from 'prop-types';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCirclePlus, faClose} from "@fortawesome/free-solid-svg-icons";

import Me from "../../assets/me.png";
import {useIsMobile} from "../Tools/useIsMobile";

const Header = ({
	isEdit,
	setIsEdit,
	onLogout,
	onSwitchProfile,
	setShowProfileManager,
	setShowAddLink,
	showAddLink,
	profile
}) => {
	const isMobile = useIsMobile(450);

	const normalizeProfileName = (profileName) => {
		const normalized = String(profileName ?? "").trim().toUpperCase();
		return normalized || "WORK";
	};

	const formatProfileName = (profileName) => {
		return normalizeProfileName(profileName)
			.toLowerCase()
			.split(/\s+/)
			.filter(Boolean)
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(" ");
	};

	const getMobileProfileTitle = (profileName) => {
		const initials = normalizeProfileName(profileName)
			.split(/\s+/)
			.filter(Boolean)
			.map((word) => word.charAt(0))
			.join("");
		return `M${initials || "W"}S`;
	};

	const title = isMobile
		? getMobileProfileTitle(profile?.profileName)
		: `My ${formatProfileName(profile?.profileName)} Space`;

	return (
		<>
			<div className="left-btn-container">
				{isEdit ? (
					<button
						aria-label="add link"
						onClick={() => setShowAddLink(!showAddLink)}
						className="add-button"
					>
						<FontAwesomeIcon icon={faCirclePlus}/>
					</button>
				) : (
					<button
						aria-label="logout"
						onClick={() => onLogout()}
						className="logout-button"
					>
						<FontAwesomeIcon icon={faClose}/>
					</button>
				)
				}
			</div>
			<h1
				onClick={() => {
					if (isEdit) {
						setShowProfileManager(true);
						return;
					}
					onSwitchProfile();
				}}
				className="title"
			>
				{title}
			</h1>
			<div className="right-btn-container">
				{isEdit ?
					<div onClick={() => setIsEdit(false)} className="close-button">
						<FontAwesomeIcon icon={faClose}/>
					</div>
					:
					<div onClick={() => setIsEdit(true)} className="edit-button">
						<img src={Me} alt="edit-button"/>
					</div>
				}
			</div>
		</>
	);
}

Header.propTypes = {
	isEdit: PropTypes.bool.isRequired,
	setIsEdit: PropTypes.func.isRequired,
	onLogout: PropTypes.func.isRequired,
	onSwitchProfile: PropTypes.func.isRequired,
	setShowProfileManager: PropTypes.func.isRequired,
	setShowAddLink: PropTypes.func.isRequired,
	showAddLink: PropTypes.bool.isRequired,
	profile: PropTypes.shape({
		id: PropTypes.string,
		profileName: PropTypes.string
	}),
};

export default Header;
